import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaigncontact-view',
  templateUrl: './campaigncontact-view.component.html',
  styleUrls: ['./campaigncontact-view.component.css']
})
export class CampaigncontactViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
